<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="15"
    viewBox="0 0 24 15"
    fill="none"
  >
    <path
      d="M2 2L12 12L22 2"
      stroke="#2B3483"
      stroke-width="3"
      stroke-linecap="round"
    />
  </svg>
</template>
<script>
export default {
  name: "BottomArr",
};
</script>
